const firebaseConfig = {
  apiKey: "AIzaSyAuDUgsJNFWIOP8gWd7tWZSlDCzZQoM3Tg",
  authDomain: "e-furniture-shop.firebaseapp.com",
  projectId: "e-furniture-shop",
  storageBucket: "e-furniture-shop.appspot.com",
  messagingSenderId: "311545475979",
  appId: "1:311545475979:web:f0459cca9dc0850143f58e",
};
export default firebaseConfig;
